import { ActionField } from "../../administration/types/Actions";
import { MetadataDefinition } from "../../administration/types/Metadata";

export const getActionMetadataDefinition = (
    field: ActionField,
    metadataDefinitions: MetadataDefinition[],
) =>
    field.resolvedMetadataDefinition ??
    metadataDefinitions.find(
        (definition) => definition.name === field.defaultValue,
    );

export const actionRequiresInput = (
    fields: ActionField[],
    metadataDefinitions: MetadataDefinition[],
) =>
    fields.some((field) => field.fieldType === "UserInput") ||
    fields.some(
        (field) =>
            field.fieldType === "Metadata" &&
            getActionMetadataDefinition(field, metadataDefinitions)
                ?.isMultiValue,
    );
